import {ReplaySubject} from "rxjs/ReplaySubject";
import {Position} from "../../types/Portfolio";
import {ArrayUtil} from "../../js/util/ArrayUtil";
import {Optional} from "../../js/util/Optional";

export class QuickWhatIfService extends ReplaySubject<Array<Position>> {

    private current: ReadonlyArray<Position>;

    constructor() {
        super(1);
    }

    private get value(): ReadonlyArray<Position> {
        return Optional.of(this.current).orElse([]);
    }

    public next(value: Array<Position>): void {
        this.current = value;
        super.next(value);
    }

    public clear() {
        this.next([]);
    }

    public add(...position: Array<Position>) {
        const clone = ArrayUtil.clone(this.value);
        const next = clone.concat(position);
        this.next(next);
    }

    public update(positions: Array<Position>) {
        this.next(positions);
    }

    public replace(oldPosition: Position, newPosition: Position): void {
        const next = ArrayUtil.replaceBy(this.value, newPosition, p => p.code === oldPosition.code);
        this.next([...next]);
    }

    public remove(position: Position) {
        const next = this.value.filter(p => p.code !== position.code);
        this.next(next);
    }
}
